/* Resin calculator (v2) — redesigned section.
   Scoped per section instance: no global IDs, safe with several instances
   on one page, re-inits on shopify:section:load (Theme Editor). */
(function () {
  'use strict';

  function parseNum(value) {
    var n = parseFloat(String(value).replace(',', '.'));
    return isFinite(n) && n > 0 ? n : 0;
  }

  /* "2.7 kg" / "300 g" / "900g" -> kilograms */
  function volumeToKg(label) {
    if (!label) return 0;
    var text = String(label).toLowerCase().replace(',', '.');
    var kg = text.match(/([\d.]+)\s*kg/);
    if (kg) return parseFloat(kg[1]) || 0;
    var g = text.match(/([\d.]+)\s*g(?![a-z])/);
    if (g) return (parseFloat(g[1]) || 0) / 1000;
    return 0;
  }

  /* "up to 15-20 mm and 2 kg per layer" -> 20 (mm).
     Only the number pair directly in front of mm/cm counts, so the kg part
     of the same sentence can never be mistaken for a thickness. */
  function depthToMm(text) {
    if (!text) return 0;
    var value = String(text).toLowerCase().replace(/,/g, '.');
    var match = value.match(/(\d+(?:\.\d+)?)\s*(?:[–—-]\s*(\d+(?:\.\d+)?)\s*)?(mm|cm)/);
    if (!match) return 0;
    var number = parseFloat(match[2] || match[1]) || 0;
    return match[3] === 'cm' ? number * 10 : number;
  }

  /* One decimal place for kilograms; grams stay whole below 1 kg. */
  function formatKg(kg) {
    if (kg < 1) return Math.round(kg * 1000) + ' g';
    return (Math.round(kg * 10) / 10).toFixed(1) + ' kg';
  }

  /* Per-type weight routing, from the section setting. One rule per line:
       project type | threshold kg | handle below | handle at or above
     e.g. "for flower preservation | 4 | crystal-epoxy-resin | wood-pro".
     Lets a type send light and heavy projects to different resins without
     touching the code. */
  function parseRules(text) {
    if (!text) return [];
    return String(text).split('\n').map(function (line) {
      var parts = line.split('|').map(function (p) { return p.trim(); });
      if (parts.length < 4 || !parts[0]) return null;
      var threshold = parseFloat(parts[1].replace(',', '.'));
      if (!isFinite(threshold)) return null;
      return {
        type: parts[0].toLowerCase(),
        threshold: threshold,
        below: parts[2],
        above: parts[3]
      };
    }).filter(Boolean);
  }

  function init(root) {
    if (!root || root.dataset.rcalcInited === 'true') return;
    root.dataset.rcalcInited = 'true';

    var density = parseFloat(root.dataset.density) || 1.15;
    var reserve = 1 + (parseFloat(root.dataset.reserve) || 0) / 100;
    var msgError = root.dataset.i18nError || '';
    var msgNoMatch = root.dataset.i18nNomatch || '';
    var msgDepth = root.dataset.i18nDepth || '';
    var msgChoose = root.dataset.i18nChoose || '';
    var rules = parseRules(root.dataset.rules);

    var shapeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-rcalc-shape]'));
    var fieldSets = Array.prototype.slice.call(root.querySelectorAll('[data-rcalc-fields]'));
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-rcalc-input]'));
    var typeInputs = Array.prototype.slice.call(root.querySelectorAll('[data-rcalc-type]'));
    var typesHint = root.querySelector('[data-rcalc-types-hint]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rcalc-card]'));
    var placeholder = root.querySelector('[data-rcalc-placeholder]');
    var weightEl = root.querySelector('[data-rcalc-weight]');
    var errorEl = root.querySelector('[data-rcalc-error]');
    var depthEl = root.querySelector('[data-rcalc-depth-warning]');
    var resetBtn = root.querySelector('[data-rcalc-reset]');

    var placeholderDefault = placeholder ? placeholder.textContent.trim() : '';
    var shape = 'box';

    function field(name) {
      var el = root.querySelector('[data-rcalc-input="' + name + '"]');
      return el ? parseNum(el.value) : 0;
    }

    function anyFilled() {
      for (var i = 0; i < inputs.length; i++) {
        var set = inputs[i].closest('[data-rcalc-fields]');
        if (set && set.hidden) continue;
        if (inputs[i].value.trim() !== '') return true;
      }
      return false;
    }

    /* Pour thickness in mm — what the per-layer limit is checked against. */
    function thicknessMm() {
      return shape === 'box' ? field('height') : field('rheight');
    }

    function requiredKg() {
      var cm3;
      if (shape === 'box') {
        var w = field('width');
        var l = field('length');
        var h = field('height');
        if (!w || !l || !h) return 0;
        cm3 = (w * l * h) / 1000; /* mm3 -> cm3 */
      } else {
        var d = field('diameter');
        var rh = field('rheight');
        if (!d || !rh) return 0;
        var r = d / 2;
        cm3 = (Math.PI * r * r * rh) / 1000;
      }
      return (cm3 * density * reserve) / 1000;
    }

    function selectedType() {
      var checked = root.querySelector('[data-rcalc-type]:checked');
      return checked ? checked.value.trim().toLowerCase() : '';
    }

    function cardTypes(card) {
      return (card.dataset.types || '').split('||').map(function (t) {
        return t.trim().toLowerCase();
      });
    }

    function cardDepthMm(card) {
      return depthToMm(card.dataset.depth);
    }

    function cardByHandle(handle) {
      if (!handle) return null;
      return cards.filter(function (c) { return c.dataset.handle === handle; })[0] || null;
    }

    function pillsOf(card) {
      return Array.prototype.slice.call(card.querySelectorAll('[data-rcalc-pill]')).map(function (el) {
        return {
          el: el,
          kg: volumeToKg(el.dataset.volume),
          available: el.dataset.available === 'true',
          id: el.dataset.variantId,
          price: el.dataset.price
        };
      });
    }

    /* Smallest available pack that covers the need, else the largest available. */
    function bestPill(pills, kg) {
      var usable = pills.filter(function (p) { return p.available && p.kg > 0; });
      if (!usable.length) return null;
      usable.sort(function (a, b) { return a.kg - b.kg; });
      for (var i = 0; i < usable.length; i++) {
        if (usable[i].kg >= kg) return usable[i];
      }
      return usable[usable.length - 1];
    }

    function applyPill(card, pill) {
      if (!pill) return;
      var idInput = card.querySelector('[data-variant-id-input]');
      var priceEl = card.querySelector('[data-rcalc-card-price]');
      var addBtn = card.querySelector('[data-rcalc-add]');

      Array.prototype.forEach.call(card.querySelectorAll('[data-rcalc-pill]'), function (el) {
        el.classList.toggle('is-selected', el === pill.el);
      });
      if (idInput) idInput.value = pill.id;
      if (priceEl && pill.price) priceEl.innerHTML = pill.price;
      if (addBtn) addBtn.disabled = !pill.available;
    }

    function showCard(card) {
      cards.forEach(function (c) { c.hidden = c !== card; });
      if (placeholder) placeholder.hidden = !!card;
    }

    /* A weight rule for this type wins outright — it encodes a deliberate
       "light projects take X, heavy ones take Y" decision. */
    function ruleCard(type, kg) {
      for (var i = 0; i < rules.length; i++) {
        if (rules[i].type !== type) continue;
        var handle = kg < rules[i].threshold ? rules[i].below : rules[i].above;
        var card = cardByHandle(handle);
        if (card) return card;
      }
      return null;
    }

    /* Otherwise: a resin that can be poured at this thickness AND covers the
       amount, then one that can be poured at this thickness, then one that
       covers the amount. Pour depth outranks pack size — a resin poured too
       thick overheats, a short pack is only an extra order. */
    function pickCard(type, kg, thickness) {
      var ruled = ruleCard(type, kg);
      if (ruled) return ruled;

      var matching = cards.filter(function (c) { return cardTypes(c).indexOf(type) !== -1; });
      if (!matching.length) return null;

      function depthOk(c) {
        var d = cardDepthMm(c);
        return !thickness || !d || d >= thickness;
      }
      function covers(c) {
        var p = bestPill(pillsOf(c), kg);
        return !!(p && p.kg >= kg);
      }

      var both = matching.filter(function (c) { return depthOk(c) && covers(c); });
      if (both.length) return both[0];
      var deep = matching.filter(depthOk);
      if (deep.length) return deep[0];
      var covering = matching.filter(covers);
      return covering[0] || matching[0];
    }

    function setError(text) {
      if (!errorEl) return;
      errorEl.textContent = text || '';
      errorEl.hidden = !text;
    }

    /* Warn when the pour is thicker than this resin takes in one layer — the
       single most expensive mistake with epoxy. */
    function setDepthWarning(card, thickness) {
      if (!depthEl) return;
      var maxMm = card ? cardDepthMm(card) : 0;
      if (!card || !thickness || !maxMm || thickness <= maxMm) {
        depthEl.hidden = true;
        depthEl.textContent = '';
        return;
      }
      depthEl.textContent = msgDepth.replace('{max}', (card.dataset.depth || '').trim());
      depthEl.hidden = false;
    }

    /* No project type is preselected, so the customer makes that choice
       deliberately. Until they do, a line under the group asks for it and
       the result column says what it is waiting on. */
    function awaitType(on) {
      if (typesHint) typesHint.hidden = !on;
      if (placeholder) placeholder.textContent = on ? (msgChoose || placeholderDefault) : placeholderDefault;
    }

    function update() {
      var kg = requiredKg();
      var thickness = thicknessMm();

      if (!kg) {
        if (weightEl) weightEl.textContent = '—';
        setError(anyFilled() ? msgError : '');
        setDepthWarning(null, 0);
        awaitType(false);
        showCard(null);
        return;
      }

      if (weightEl) weightEl.textContent = formatKg(kg);
      setError('');

      var type = selectedType();
      if (!type) {
        setDepthWarning(null, 0);
        awaitType(true);
        showCard(null);
        return;
      }

      awaitType(false);

      var card = pickCard(type, kg, thickness);
      if (!card) {
        setError(msgNoMatch);
        setDepthWarning(null, 0);
        showCard(null);
        return;
      }

      applyPill(card, bestPill(pillsOf(card), kg));
      setDepthWarning(card, thickness);
      showCard(card);
    }

    shapeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        shape = btn.getAttribute('data-rcalc-shape');
        shapeBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        fieldSets.forEach(function (set) {
          set.hidden = set.getAttribute('data-rcalc-fields') !== shape;
        });
        update();
      });
    });

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var cleaned = input.value.replace(/[^0-9.,]/g, '');
        if (cleaned !== input.value) input.value = cleaned;
        update();
      });
    });

    typeInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    /* Manual pack choice stays until the dimensions change again. */
    root.addEventListener('click', function (event) {
      var pillEl = event.target.closest ? event.target.closest('[data-rcalc-pill]') : null;
      if (!pillEl) return;
      var card = pillEl.closest('[data-rcalc-card]');
      if (!card) return;
      var pill = pillsOf(card).filter(function (p) { return p.el === pillEl; })[0];
      applyPill(card, pill);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        inputs.forEach(function (input) { input.value = ''; });
        typeInputs.forEach(function (input) { input.checked = false; });
        update();
      });
    }

    var tip = root.querySelector('[data-rcalc-tip]');
    if (tip) {
      var tipBtn = tip.querySelector('.rcalc__tip-btn');
      if (tipBtn) {
        tipBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          var open = tip.classList.toggle('is-open');
          tipBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        document.addEventListener('click', function () {
          tip.classList.remove('is-open');
          tipBtn.setAttribute('aria-expanded', 'false');
        });
      }
    }

    update();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-rcalc]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
